export const ROUTES = {
  LOGIN: '/login',
  CREATE_ACCOUNT: '/create-account',
  FORGET_PASSWORD: '/forget-password',
  HOME: '/',
  CHECKOUT: '/checkout',
  PAYMENT: '/payment',
  PAYMENT_CONFIRMATION: '/payment-confirmation/:paymentId',
};
